<template>
  <form>
    <md-card style="max-height: 500px">
      <md-card-header class="md-card-header-text md-card-header-green">
        <div class="card-text">
          <h4 class="title">Application Chat</h4>
          <p class="category">Student Application Chat</p>
        </div>
      </md-card-header>
      <md-card-content class="md-size-50 mx-auto" v-if="table_spinner">
        <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
      </md-card-content>
      <md-card-content style="overflow: auto;">
        <div
          class="alert alert-info alert-with-icon chat-header-top"
          v-for="item in application_chats"
          v-bind:key="item.id"
          v-bind:class="{
            'chat-header-student': isStudentClass(item.user.role)
          }"
        >
          <i data-notify="icon" class="chat-header"
            >{{ item.user.first_name }} {{ item.user.last_name }} -
            {{ item.created_date }}</i
          >
          <span style="font-weight: bold; font-size: 15px">{{
            item.message
          }}</span>
        </div>
      </md-card-content>
      <div>
        <div class="md-layout">
          <div class="md-layout-item md-size-80">
            <ValidationProvider name="website">
              <md-field>
                <md-icon>book_online</md-icon>
                <label>Message</label>
                <md-input v-model="message" type="text"> </md-input>
              </md-field>
            </ValidationProvider>
          </div>
          <div class="md-layout-item md-size-10">
            <md-button
              style="margin-right: 10px;"
              :disabled="disabled"
              class="md-just-icon md-success md-round mg-10"
              @click="addChat"
            >
              <md-icon>send</md-icon>
              <md-tooltip md-direction="bottom">Send</md-tooltip>
            </md-button>
          </div>
        </div>
      </div>
    </md-card>
  </form>
</template>
<script>
export default {
  props: {
    headerColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      applicationID: null,
      application_chats: [],
      table_spinner: true,
      message: null,
      disabled: false
    };
  },
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    isStudentClass: function(role) {
      return role === "Student";
    },
    addChat: function() {
      if (!this.message) {
        return;
      }
      let data = {
        message: this.message
      };
      this.disabled = true;
      this.$store
        .addApplicationChat(this.applicationID, data)
        .then(response => {
          this.application_chats.push(response.data);
          this.message = null;
          this.disabled = false;
        })
        .catch(error => {
          this.$notify({
            message: error.message,
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top"
          });
          this.disabled = false;
        });
    }
  },
  mounted() {
    this.applicationID = this.$route.params.application_id;
    this.$store
      .getApplicationChats(this.applicationID)
      .then(response => {
        this.application_chats = response.data;
        this.table_spinner = false;
      })
      .catch(error => {
        this.table_spinner = false;
        this.$notify({
          message: error.message,
          icon: "add_alert",
          type: "warning",
          verticalAlign: "top"
        });
      });
  }
};
</script>
<style>
.chat-header {
  border-radius: 10px 10px 10px 10px !important;
  max-width: 300px !important;
  margin-top: -38px !important;
  color: white !important;
  background: linear-gradient(60deg, #80ba82, #4e9f52) !important;
  font-size: 12px !important;
  font-style: normal !important;
  padding: 5px !important;
}

.chat-header-top {
  width: 75%;
  border-radius: 10px 10px 10px 10px !important;
  background: linear-gradient(60deg, #26c6da, #00acc1);
  box-shadow: black;
}

.chat-header-student {
  margin-left: 25%;
}
</style>
